goog.provide("shadow.js.shim.module$dayjs$locale$nb");
goog.provide("module$shadow_js_shim_module$dayjs$locale$nb");
shadow.js.shim.module$dayjs$locale$nb = shadow.js.nativeProvides["dayjs/locale/nb"] = require("dayjs/locale/nb");
module$shadow_js_shim_module$dayjs$locale$nb.default = shadow.js.shim.module$dayjs$locale$nb;
